module.exports = __webpack_public_path__ + "img/switchOn.c1e0373a.svg";